import React, { useState, useEffect } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import rapidex from '../images/rapidex.png';
import caixaAssistencia from '../images/caixa_assistencia.png';
import { useNavigate } from "react-router-dom";
import { getPropostaId, cancelarProposta, gerarBoleto2via, getProposta2Via, finalizaAnexo, gerarBoleto } from "../componentes/api/DataApi";
import { useLocation } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';
import LoadingMask from "../componentes/LoadingMask";
import Modal from "react-bootstrap/Modal";
import { useDropzone } from 'react-dropzone';
import { AiOutlineClose, AiOutlineFileText } from "react-icons/ai";

const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export default function PropostaDetalhePage() {
    const navigate = useNavigate();
    const location = useLocation()
    const params = new URLSearchParams(location.search)

    const [loading, setLoading] = useState(false);
    const [proposta, setProposta] = useState();
    const [loadingMask, setLoadingMask] = useState(false);
    const [modalCancelar, setModalCancelar] = useState(false);
    const [modalBoleto, setModalBoleto] = useState(false);
    const [modalCanceladaSucesso, setModalCanceladaSucesso] = useState(false);
    const [modalCanceladaErro, setModalCanceladaErro] = useState('');
    const [mensagemErroBoleto, setMensagemErroBoleto] = useState('');
    const [arquivoAnexado, setArquivoAnexado] = useState(false);
    const [modalErro, setModalErro] = useState(false);
    const [mensagemErro, setMensagemErro] = useState();
    const [propostaFinalizada, setPropostaFinalizada] = useState(false);

    useEffect(() => {
        if (params && params.get("id") !== null) {
            retornaPropostaPeloId();
        }
        else {
            navigate("/venda");
        }
    }, []);

    const retornaPropostaPeloId = () => {
        setLoading(true);

        getPropostaId(params.get("id"), (response) => {
            setLoading(false);

            if (response && response.codigo === 0) {
                setProposta(response.vendas[0]);
            }
            else {
                navigate("/venda");
            }
        });
    }

    const onVoltar = () => {
        navigate("/proposta?cpf=" + proposta.cpfCnpj);
    }

    const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone({
        maxFiles: 1,
        noClick: true,
        noKeyboard: true,
        noDrag: true,
        maxSize: 5000000,
        accept: {
            'application/pdf': ['.pdf']
        },
        onFileDialogOpen: files => {
            setArquivoAnexado(false);
        },
        onDropAccepted: files => {
            setArquivoAnexado(true);

            let reader = new FileReader();
            reader.readAsDataURL(files[0]);

            reader.onload = function () {
                setProposta({
                    ...proposta,
                    arquivo_proposta: {
                        nome: files[0].name,
                        tipo: files[0].type,
                        arquivo: replaceAll(reader.result, "data:application/pdf;base64,", ""),
                        tamanho: files[0].size,
                        documento: 1
                    }
                });
            };
        },
        onDropRejected: files => {
            let code = files[0].errors[0].code;

            setModalErro(true);
            setArquivoAnexado(false);

            if (code === "file-invalid-type") {
                setMensagemErro("Não é possível anexar aquivo que não seja do tipo PDF");
            }
            else if (code === "file-too-large") {
                setMensagemErro("Tamanho do arquivo maior do que o permitido, máximo permitido 700k");
            }
            else {
                setMensagemErro("Erro desconhecido, entre em contato com o suporte");
            }
        }
    });

    const limparAnexo = () => {
        setArquivoAnexado(false);
        acceptedFiles.pop();
    }

    const files = acceptedFiles.map(file => (
        <div key={file.path}>
            <AiOutlineClose size={20} color="red" style={{cursor: "pointer"}} onClick={() => limparAnexo()}></AiOutlineClose> <AiOutlineFileText size={20}></AiOutlineFileText>{file.path}
        </div>
    ));

    const onCancelarProposta = () => {
        setLoadingMask(true);

        cancelarProposta(proposta.id, (response) => {
            setLoadingMask(false);

            if (response.codigo === 0) {
                setModalCancelar(false);
                setModalCanceladaSucesso(true);
            }
            else if (response.codigo === -2) {
                setModalCancelar(false);
                setModalCanceladaErro(response.mensagem);
            }
        });
    }

    const onBoleto = () => {
        if (proposta.podeGerarNovoBoleto) {
            setLoadingMask(true);

            gerarBoleto2via(proposta.id, async (response) => {
                setLoadingMask(false);

                if (response.codigo === 0) {
                    let arquivoBase64 = "data:" + response.tipo + ";base64," + response.boleto;

                    const pdfstr = await fetch(arquivoBase64);

                    const blobFromFetch= await pdfstr.blob();

                    var blob = new Blob([blobFromFetch], {type: response.tipo});
                
                    const blobUrl = URL.createObjectURL(blob)
    
                    window.open(blobUrl, "_blank");
        
                }
                else {
                    setMensagemErroBoleto(response.mensagem);
                }
            });
        }
        else {
            setModalBoleto(true);
        }
    }

    const onBotaoFecharCancelarSucesso = () => {
        setModalCanceladaSucesso(false);

        navigate("/venda");
    }

    const onGeraPdfProposta = () => {
        setLoadingMask(true);

        getProposta2Via(proposta.id, proposta.codigoProduto, proposta.renovacaoAutomatica, async (response) => {
            setLoadingMask(false);

            if (response) {
                if (response?.codigo <= -1) {
                    window.alert("Erro na criação do contrato");
                }
                else {
                    const base64Response = await fetch(`data:application/pdf;base64,${response.proposta}`);

                    const blobFromFetch= await base64Response.blob();
    
                    var blob = new Blob([blobFromFetch], {type: "application/pdf"});
                    
                    const blobUrl = URL.createObjectURL(blob);
                
                    window.open(blobUrl,"_blank");                
                    window.open(blobUrl,"_blank");    
                }
            }
        });
    }

    const onBoletoNovo = () => {
        setLoadingMask(true);

        gerarBoleto(proposta.cpfCnpj, proposta.valor, proposta.nome, proposta.modalidade, proposta.numProposta, proposta.id, (response) => {
            setLoadingMask(false);

            if (response.codigo === 0) {
                if (response.url) {
                    window.open(response.url, '_blank');
                }

                retornaPropostaPeloId();
            }
            else {
                setMensagemErroBoleto(response.mensagem);
            }
        });
    }

    const onAnexarProposta = () => {
        setLoadingMask(true);

        finalizaAnexo(proposta, (response) => {
            setLoadingMask(false);

            if (response.codigo === 0) {
                if (response.url) {
                    window.open(response.url, '_blank');
                }

                retornaPropostaPeloId();
            }
            else {
                setMensagemErroBoleto(response.mensagem);
            }
        });
    }

    return (    
        <>
            {loading &&
                <>
                    <div className="d-flex flex-column w-100 align-items-center">
                        <div className="d-flex flex-column bg-padrao align-items-center h-full" style={{ width: "1150px" }}>
                            <div className="d-flex flex-column h-full" style={{ width: "100%" }}>
                                <Skeleton height={"20px"} />
                            </div>
                        </div>
                    </div>
                </>
            }

            {!loading && proposta &&
                <>
                <LoadingMask loading={loadingMask} text={"Aguarde..."}>
                    <div className="d-flex flex-column w-100 align-items-center">
                        <div className="d-flex flex-column bg-padrao align-items-center h-full" style={{ width: "1150px" }}>
                            <div className="d-flex flex-row justify-content-between w-100">
                                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                                    <img src={rapidex} alt=""></img>
                                </div>
                                <img src={caixaAssistencia} alt=""></img>
                            </div>

                            <div className="d-flex flex-column align-items-center" style={{marginTop: '100px', width: '800px', border: "1px solid #aaa", marginBottom: "80px"}}>
                                <div className="d-flex flex-column" style={{width: '800px'}}>
                                    <div className="d-flex flex-column tituloVenda w-100">
                                        PROPOSTA - {proposta?.numProposta}
                                    </div>
                                </div>

                                <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                    <div className="d-flex flex-column" style={{padding: '10px 10px 10px 10px'}}>
                                        <div>Data/Hora: {proposta.data}</div>
                                        <div>Nome do produto: {proposta.produto}</div>
                                        <div>Nome da empresa: {proposta.empresa}</div>
                                        <div>CNPJ: {proposta.empresaCnpj}</div>
                                        <div>Nome: {proposta.nome}</div>
                                        <div>CPF/CNPJ: {proposta.cpfCnpjMask}</div>
                                        <div>Agência: {proposta.agencia} CC: {proposta.conta}</div>
                                        <div>N. da proposta: {proposta.numProposta}</div>
                                        <div>Celular (SMS): {proposta.vendaCelular}</div>
                                        <div>Modalidade: {proposta.modalidade}</div>
                                        <div>Valor pago: R$ {proposta.valor}</div>
                                        <div>Vigência: {proposta.vigencia}</div>
                                        <div>Início da vigência: {proposta.inicioVigencia}</div>
                                        <div>Situação: {proposta.situacao}</div>
                                        {proposta.vincularProposta &&
                                            <>
                                            {acceptedFiles && acceptedFiles.length > 0 &&
                                                <>
                                                <div style={{marginBottom: 2, marginTop: 30}}>Proposta:</div>
                                                <div style={{marginBottom: 10}}>
                                                    {files}
                                                </div>
                                                <button className="botaoNovaProposta" style={{cursor: "pointer", marginBottom: '10px'}} onClick={onAnexarProposta}>ENVIAR PROPOSTA</button>
                                                </>
                                            }
                                            </>
                                        }
                                    </div>

                                    <div className="d-flex flex-column me-4">
                                        {!proposta.debitado &&
                                            <button className="botaoNovaProposta" style={{cursor: "pointer", marginBottom: '10px'}} onClick={() => setModalCancelar(true) }>CANCELAR</button>
                                        }
                                        {proposta.boleto && !proposta.boletoAtrasado &&
                                            <button className="botaoNovaProposta" style={{cursor: "pointer", marginBottom: '10px'}} onClick={onBoleto}>2. VIA DO BOLETO</button>
                                        }
                                        {proposta.boletoAtrasado &&
                                            <button className="botaoNovaProposta" style={{cursor: "pointer", marginBottom: '10px'}} onClick={onBoletoNovo}>IMPRIMIR BOLETO</button>
                                        }
                                        {!proposta.vincularProposta ?
                                            <button className="botaoNovaProposta" style={{cursor: "pointer", marginBottom: '10px'}} onClick={onGeraPdfProposta}>IMPRIMIR PROPOSTA</button>
                                        :
                                        <>
                                            {!arquivoAnexado &&
                                                <div {...getRootProps()}>
                                                        <>
                                                            <input {...getInputProps()} />
                                                            <button className="botaoNovaProposta" style={{cursor: "pointer", marginBottom: '10px'}} onClick={open}>ANEXAR PROPOSTA</button>
                                                        </>
                                                </div>
                                            }
                                        </>
                                        }
                                        <button className="botaoNovaProposta" style={{cursor: "pointer"}} onClick={onVoltar}>VOLTAR</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </LoadingMask>

                <Modal show={modalCanceladaErro !== ''} centered={true}>
                    <Modal.Header className="cabecalho_modal">
                        Atenção:
                    </Modal.Header>
                    <Modal.Body>
                        <div className="w-100">
                            <center>
                                <b>{modalCanceladaErro}</b>
                            </center>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex flex-row">
                            <button type="button" className="botaoLaranja" style={{width: "110px"}} onClick={() => setModalCanceladaErro('')}>Fechar</button>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={modalCanceladaSucesso} centered={true}>
                    <Modal.Header className="cabecalho_modal">
                        Atenção:
                    </Modal.Header>
                    <Modal.Body>
                        <div className="w-100">
                            <center>
                                <b>Proposta cancelada com sucesso!</b>
                            </center>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex flex-row">
                            <button type="button" className="botaoLaranja" style={{width: "110px"}} onClick={onBotaoFecharCancelarSucesso}>Fechar</button>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={mensagemErroBoleto !== ''} centered={true}>
                    <Modal.Header className="cabecalho_modal">
                        Atenção:
                    </Modal.Header>
                    <Modal.Body>
                        <div className="w-100">
                            <center>
                                <b>{mensagemErroBoleto}</b>
                            </center>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex flex-row">
                            <button type="button" className="botaoLaranja" style={{width: "110px"}} onClick={() => {setMensagemErroBoleto('')}}>Fechar</button>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={modalBoleto} centered={true}>
                    <Modal.Header className="cabecalho_modal">
                        Atenção:
                    </Modal.Header>
                    <Modal.Body>
                        <div className="w-100">
                            <center>
                                {proposta.codSituacao === 9 ?
                                    <b>Boleto não pode ser re-emitido porque a proposta encontra-se cancelada!</b>
                                :
                                    <b>Boleto não pode ser re-emitido porque o período de reemissão já ultrapassado!</b>
                                }
                            </center>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex flex-row">
                            <button type="button" className="botaoLaranja" style={{width: "110px"}} onClick={() => setModalBoleto(false)}>Fechar</button>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={modalCancelar} centered={true}>
                    <LoadingMask loading={loadingMask} text={"Aguarde..."}>
                        <Modal.Header className="cabecalho_modal">
                            Atenção:
                        </Modal.Header>
                        <Modal.Body>
                            <div className="w-100">
                                <center>
                                    {proposta.codSituacao === 3 ?
                                        <b>Proposta já enviada para processamento!</b>
                                    :
                                        <>
                                        {proposta.situacao === 9 ?
                                            <b>Proposta já está cancelada!</b>
                                        :
                                            <b>Tem certeza que deseja cancelar o seu {proposta.produto}?</b>
                                        }
                                        </>
                                    }
                                </center>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex flex-row">
                                {proposta.codSituacao >= 3 ?
                                    <>
                                        <button type="button" className="botaoLaranja" style={{width: "110px"}} onClick={() => setModalCancelar(false)}>Fechar</button>
                                    </>
                                :
                                    <>
                                        <button type="button" className="botaoAzul" style={{marginRight: "10px", width: "110px"}} onClick={() => onCancelarProposta()}>Sim</button>
                                        <button type="button" className="botaoLaranja" style={{width: "110px"}} onClick={() => setModalCancelar(false)}>Não</button>
                                    </>
                                }
                            </div>
                        </Modal.Footer>
                    </LoadingMask>
                </Modal>

                <Modal show={modalErro} centered={true} dialogClassName="modalTutorial">
                    <Modal.Body>
                        <div className="d-flex flex-column align-items-center w-100">
                            {mensagemErro &&
                                <div style={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}>
                                    {mensagemErro}
                                </div>
                            }

                            <input type="button" value="Fechar" style={{ marginBottom: "10px", marginTop: "20px", backgroundColor: "#93c467", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "150px" }} onClick={() => setModalErro(false)} />
                        </div>
                    </Modal.Body>
                </Modal>
           </>
            }
        </>
    )
}
